"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _CircularLoader = _interopRequireDefault(require("../CircularLoader"));
var _BrandLogo = _interopRequireDefault(require("./components/BrandLogo"));
var _excluded = ["image", "name", "isLoading", "isAvailable"];
var OAuthListItem = function OAuthListItem(_ref) {
  var image = _ref.image,
    name = _ref.name,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$isAvailable = _ref.isAvailable,
    isAvailable = _ref$isAvailable === void 0 ? true : _ref$isAvailable,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var disabled = rest.disabled || !isAvailable || isLoading;
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, rest, {
    disabled: disabled,
    className: (0, _classnames["default"])('inline-flex flex-col items-center mr-8 last:mr-0', {
      'opacity-75 cursor-default': disabled
    })
  }), /*#__PURE__*/_react["default"].createElement(_BrandLogo["default"], {
    src: image,
    alt: name
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      hidden: !isLoading
    })
  }, /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
    size: 24
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      hidden: isLoading
    })
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-light mb-1 last:mb-0"
  }, name), !isAvailable && /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-light text-sm"
  }, t('retrofit.oauthList.item.comingSoon'))));
};
var _default = exports["default"] = OAuthListItem;
//# sourceMappingURL=OAuthListItem.js.map